import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

/** 状态定义 */

const store = new Vuex.Store({
  state: {
    activeTab: 1,
    commit: '',
    found: '',
    activeshu: '',
    flag: false,
    status: '',//是否可编辑
    prpdetail: {},
    sign: false, //是否详情页跳转
    screenObj: {}, // 筛选页参数
    pagedate: {}, // 筛选页条数
    ClaimNum: '', // 我的理赔:选中的num
    ClaimDetail: {}, // 我的理赔详情
    ClaimId: '', // 我的理赔:报案号
    classCode: '',// 我的理赔:险类
    appToken: '',//token
    policyNo: '',//保单号
    policyInfo: '',//保单详情
    activeIndex:''
  },
  getters: {},
  mutations: {
    setActiveTab(state, value) {
      state.activeTab = value
    },
    CommitTime(state, value) {
      state.commit = value
    },
    Showfound(state, value) {
      state.found = value
    },
    Setactiveshu(state, value) {
      state.activeshu = value
    },
    Setflag(state, value) {
      state.flag = value
    },
    setStatus(state, value) {
      state.status = value
    },
    Getprpdetail(state, value) {
      state.prpdetail = value
    },
    setSign(state, value) {
      state.sign = value
    },
    GetscreenObj(state, value) {
      state.screenObj = value
    },
    Getpagedate(state, value) {
      state.pagedate = value
    },
    // 我的理赔:选中的num
    setClaimNum(state, value) {
      state.ClaimNum = value
    },
    // 我的理赔详情
    setClaimDetail(state, value) {
      state.ClaimDetail = value
    },
    // 我的理赔:报案号
    setClaimId(state, value) {
      state.ClaimId = value
    },
    // 我的理赔:险类
    setclassCode(state, value) {
      state.classCode = value
    },
    //存储token
    setAppToken(state, value) {
      state.appToken = value;
    },
    //存储保单号
    setPolicyNo(state, value) {
      state.policyNo = value;
    },
    //存储保单详情
    setPolicyInfo(state, value) {
      state.policyInfo = value;
    },
    //判断承保还是理赔
    changeActiveIndex(state, value) {
        state.activeIndex = value;
     },
  },
  actions: {}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js